<template>
  <el-dialog :visible.sync="state" :title="plustitle" width="580px" custom-class="c-docs" :close-on-click-modal="false" @open="bindGetData">
    <div class="m-form">
      <el-form label-width="140px">
        <el-form-item label="应用ID" style="width: 320px" v-if="landData.state === 2">
          <span>{{ landData.id }}</span>
        </el-form-item>
        <el-form-item label="媒体" prop="mediaId">
          <ThrottleSelector
            :list="mediaCallbackAddr"
            :popper-append-to-body="false"
            v-model="landData.mediaId"
            placeholder="请选择媒体"
            style="width: 320px"
            @change="handleMedia"
          />
        </el-form-item>
        <el-form-item label="回调地址">
          <div>
            <span v-if="landData.callbackAddr === '' || landData.callbackAddr === undefined">&nbsp;</span>
            <span v-else>{{ landData.callbackAddr }}</span>
          </div>
          <div>
            <span class="mark">注:请将该链接填到媒体应用的回调链接处</span>
          </div>
        </el-form-item>
        <el-form-item label="应用名称">
          <el-input v-model.trim="landData.appName" type="text" style="width: 320px" placeholder="请输入应用名称" :maxlength="100" />
        </el-form-item>
        <el-form-item label="APPID">
          <el-input v-model.trim="landData.appId" type="text" style="width: 320px" placeholder="请输入APPID" :maxlength="100" />
        </el-form-item>
        <el-form-item label="加密秘钥">
          <el-input v-model.trim="landData.encryptionKey" type="text" style="width: 320px" placeholder="请输入加密秘钥" :maxlength="1000" />
        </el-form-item>
        <el-form-item label="授权地址">
          <el-input
            v-model.trim="landData.authorizedAddr"
            type="text"
            style="width: 320px"
            placeholder="请输入授权地址"
            :maxlength="1000"
          />
        </el-form-item>
        <el-form-item label="管理账号" prop="manageId">
          <ThrottleSelector
            :popper-append-to-body="false"
            v-model="landData.manageId"
            @change="handleManage"
            @on-clear="handleManage"
            :list="landData.adAccountList"
            style="width: 320px"
            placeholder="请选择管理账号"
            filterable
            clearable
          />

          <div>
            <span class="mark">注:该管理账号用于API请求一些固定数据的操作</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 提交表单 -->
    <template slot="footer">
      <div class="m-foot">
        <el-button @click="$emit('input', false)">取消</el-button>
        <el-button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { trim, isArray } from '@/common/js/utils'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import { queryAdAccountByMediaId } from '@/api/developerConfig.model'
export default {
  name: 'developerConfigSet',
  components: { ThrottleSelector },
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },

    edit: {
      type: Boolean,
      default() {
        return false
      }
    },
    mediaCallbackAddr: {
      type: Array
    },
    adAccount: {
      type: Array
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    plustitle() {
      return `${this.edit ? '编辑' : '添加'}${this.title}`
    },
    rows() {
      return this.landData.docContent && this.landData.docContent.split(/\r?\n/).filter((ret) => trim(ret)).length
    }
  },

  methods: {
    bindGetData() {
      this.landData = {
        id: '',
        appId: '',
        mediaId: '',
        appName: '',
        callbackAddr: '',
        encryptionKey: '',
        authorizedAddr: '',
        manageId: '',
        state: 1,
        adAccountList: []
      }
    },
    setForm(form) {
      this.landData = { ...form }
    },
    // 选择媒体
    handleMedia(mediaId) {
      if (mediaId) {
        const meta = this.mediaCallbackAddr.filter((ret) => ret.id === mediaId)[0]
        this.landData.manageId = ''
        this.getAdAccountByMediaId(mediaId)
        this.landData.mediaId = mediaId
        this.landData.callbackAddr = meta.callbackAddr || '-'
      }
    },
    getAdAccountByMediaId(meta) {
      if (meta) {
        const params = { mediaId: meta }
        queryAdAccountByMediaId(params)
          .then((data) => {
            if (!data && isArray(data)) return
            this.landData.adAccountList = data.map((ret) => {
              return {
                id: ret.id,
                name: ret.adAccount
              }
            })
          })
          .catch((err) => {
            this.$message.error(err)
          })
      }
    },
    // 选择管理账号
    handleManage(meta) {
      if (meta) {
        this.landData.manageId = meta.id
      }
    },
    // 提交验证
    save() {
      if (!this.landData.mediaId) {
        this.$message.error('媒体不能为空!')
        return
      }
      if (this.landData.mediaId !== 45 && !this.landData.callbackAddr) {
        this.$message.error('回调地址不能为空!')
        return
      }
      if (!this.landData.appName) {
        this.$message.error('应用名称不能为空!')
        return
      }
      if (!this.landData.appId) {
        this.$message.error('APPID不能为空!')
        return
      }
      if (!this.landData.encryptionKey) {
        this.$message.error('加密秘钥不能为空!')
        return
      }
      // if (!this.landData.authorizedAddr) {
      //   this.$Message.error('授权地址不能为空!')
      //   return
      // }
      // if (!this.landData.manageId) {
      //   this.$Message.error('管理账号不能为空!')
      //   return
      // }
      this.$emit('on-save', this.landData)
    }
  },
  data() {
    return {
      groupState: null,
      landData: {
        id: '',
        appId: '',
        mediaId: '',
        appName: '',
        callbackAddr: '',
        encryptionKey: '',
        authorizedAddr: '',
        manageId: '',
        state: 1,
        adAccountList: []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .c-docs {
  position: relative;
  .m-form {
    overflow: auto;
    max-height: 520px;

    .mark {
      color: #ff6400;
      font-size: 12px;
    }
    .el-form-item {
      margin-bottom: 8px;
    }
  }

  .m-foot {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
